import React from 'react';
import { SyncStatus } from 'components/TaskSyncTracker/types';
import { CustomTaskScopeNameEnum } from 'constants/enums';
import { APP_URLS } from 'constants/urls';
import { shouldFetchSyncTasks } from './syncTasks';

type ShouldFetchTasksArgs = {
  completionTotalCount: number;
  isOnline: boolean;
  isServiceWorkerReady: boolean;
  lastTasksFetchTimeRef: React.MutableRefObject<Date | null>;
  pathname: string;
  search: string;
  syncStatus: SyncStatus;
  syncTrackerSeconds: string | undefined;
};

export const shouldFetchTasks = ({
  completionTotalCount,
  isOnline,
  isServiceWorkerReady,
  lastTasksFetchTimeRef,
  pathname,
  search,
  syncStatus,
  syncTrackerSeconds,
}: ShouldFetchTasksArgs): boolean => {
  const fromShouldFetchSyncTasks = shouldFetchSyncTasks({
    completionTotalCount,
    isOnline,
    isServiceWorkerReady,
    lastTasksFetchTimeRef,
    syncStatus,
    syncTrackerSeconds,
  });

  // `isTheSameUrlAs` short-circuits on path equality and never inspects
  // the `params`, so the previous form was effectively
  // "any `/perform-tasks` URL" — including foreign tabs like the one
  // Scanner navigates to after FindTasks. Inspect the `tab` query param
  // directly so this branch only fires for the offline-prep Downloads
  // tab it was designed for.
  const tabParam =
    typeof window !== 'undefined'
      ? new URLSearchParams(search).get('tab')
      : null;
  const fromTasksDownloadsUrl =
    isOnline &&
    pathname === APP_URLS.app.tasks.index.path &&
    tabParam === CustomTaskScopeNameEnum.Downloads;

  return fromShouldFetchSyncTasks || fromTasksDownloadsUrl;
};
